module.exports = __webpack_public_path__ + "img/32Ox1OO.0f02a684.svg";